import PreviewDListlImg from 'assets/images/feature-slots/preview_list.png';
import { SLOT_KEY, getRouteName } from './common';

const MODULE_NAME = 'Scheduler';

const routes = [
	{
		matchRegex: '/Scheduler',
		name: getRouteName(MODULE_NAME, 'Planner'),
		slots: [SLOT_KEY.SLOT_V_SECTION, SLOT_KEY.SLOT_SCRIPTS],
		image: PreviewDListlImg,
		parentKeys: {
			[SLOT_KEY.SLOT_V_SECTION]: [
				{ key: 'wrapper-sidebar-job-list-item', label: 'Planner Sidebar Job List Item' },
			],
		},
		options: {
			[SLOT_KEY.SLOT_SCRIPTS]: [
				{ key: 'MARKETPLACE_EVENT_FETCH_LIST_ENGINEERS_PREDICT_SUCCESS', label: 'Fetch List Engineers Predict Success' },
				{ key: 'MARKETPLACE_EVENT_GET_PERMISSION_AI_SUGGESTION', label: 'Get Permission AI Suggestion' },
			],
		},
	},
];

export default routes;
